export default __webpack_public_path__ + "alberta-productgroup.522910d4ff453e8dc412.svg";